"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Pagination_1 = __importDefault(require("react-bootstrap/Pagination"));
const appPagination_module_css_1 = __importDefault(require("./styles/appPagination.module.css"));
const getPages = (container, total, current, limit) => {
    const pages = [];
    let ellipsisLimit; // макс кол-во страниц
    let ellipsisLimitPart; // где начинаем дробить список на два, где слева ... и справа
    const ellipsisPartOffset = 5; // сколько при дроблении выводим по бокам
    if (container) {
        ellipsisLimit = Math.ceil(container.getBoundingClientRect().width / 33);
        ellipsisLimitPart = Math.ceil(ellipsisLimit / 2) - 2;
    }
    if (!limit || !ellipsisLimit)
        return pages;
    const totalPages = Math.ceil(total / limit);
    const ellipsis = [];
    if (total > ellipsisLimit) {
        if (current < ellipsisLimitPart || current > total - ellipsisLimitPart - ellipsisPartOffset) {
            ellipsis.push({
                start: Math.ceil(ellipsisLimit / 2),
                end: Math.ceil(ellipsisLimit / 2) + total - ellipsisLimit + 2,
            });
        }
        else {
            ellipsis.push({
                start: ellipsisLimitPart - ellipsisPartOffset,
                end: current - ellipsisPartOffset,
            });
            ellipsis.push({
                start: current + ellipsisPartOffset,
                end: Math.ceil(ellipsisLimit / 2) + total - ellipsisLimit + 4,
            });
        }
    }
    for (let i = 1; i <= totalPages; i++) {
        const skip = ellipsis.find((f) => f.start <= i && f.end >= i);
        if (skip && skip.start < i && skip.end >= i)
            continue;
        pages.push({
            page: i,
            isEllipsis: skip && skip.start == i ? true : false,
        });
    }
    return pages;
};
const AppPagination = ({ onChange, limit, page }) => {
    const container = (0, react_1.useRef)();
    const [current, setCurrent] = (0, react_1.useState)(page.current_page || 1);
    const pages = getPages(container.current, page.count, current, page.page_size || limit || 50);
    const handleClick = (n) => {
        setCurrent(n);
        onChange(n);
    };
    if (page.count <= 1) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(Pagination_1.default, Object.assign({ className: appPagination_module_css_1.default.container, ref: container }, { children: pages.map((page) => page.isEllipsis ? ((0, jsx_runtime_1.jsx)("span", Object.assign({ className: appPagination_module_css_1.default.Ellipsis }, { children: "..." }), page.page)) : ((0, jsx_runtime_1.jsx)(Pagination_1.default.Item, Object.assign({ className: appPagination_module_css_1.default.item, linkClassName: `btn btn-xs ${current === page.page ? "btn-primary" : ""}`, onClick: () => handleClick(page.page), active: current === page.page }, { children: page.page }), page.page))) })));
};
exports.default = AppPagination;
